/**
 * ag-grid-community - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
 * @version v19.1.4
 * @link http://www.ag-grid.com/
 * @license MIT
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var eventKeys_1 = require("./eventKeys");

exports.Events = eventKeys_1.Events;